export var widths = ['very thin', 'thin', 'wide', 'very wide'];
export var widthsInPixels = {
  'very thin': 60,
  thin: 150,
  wide: 350,
  'very wide': 475,
  '': 260 // default width for sidebars
};